import {
  IMinerSettings,
  MinerBaseEvent,
  MinerCustomerEvent,
  MinerSettingsEvent,
  SocketEventTypes,
} from "@services/http/socket/responses";
import { MinerActionData, MinerActions } from "./minerReducer";
import { IMiningPlanOptions } from "@services/getMinerList";

export const onSocketEvent = (
  type: SocketEventTypes,
  data: MinerBaseEvent<any> | IMiningPlanOptions,
  dispatchMiner: React.Dispatch<MinerActionData>
) => {
  switch (type) {

    // два события идут в одном, через сокет listener
    // case SocketEventTypes.MINER_STATUS:
    //   dispatchMiner({
    //     type: MinerActions.Status,
    //     payload: data,
    //   });
    //   break;

    // case SocketEventTypes.MINER_HASRATE:
    //   dispatchMiner({
    //     type: MinerActions.Hashrate,
    //     payload: data,
    //   });
    //   break;

    case SocketEventTypes.MINER_ADMIN_START_STOP:
      dispatchMiner({
        type: MinerActions.AdminStartStop,
        payload: data,
      });
      break;

    case SocketEventTypes.MINER_START_STOP:
      dispatchMiner({
        type: MinerActions.StartStop,
        payload: data,
      });
      break;

    case SocketEventTypes.MINER_SETTINGS_SPEED:
      dispatchMiner({
        type: MinerActions.SettingsSpeed,
        payload: data,
      });
      break;

    case SocketEventTypes.MINER_HASH_SPEED:
      dispatchMiner({
        type: MinerActions.AlgoSpeed,
        payload: data,
      });
      break;

    case SocketEventTypes.MINER_ID:
      dispatchMiner({
        type: MinerActions.MinerId,
        payload: data,
      });
      break;

    case SocketEventTypes.MINER_LOCATION:
      //такого интерфейса нет, какое-то старое сообщение сокета
      const location = data as any;
      dispatchMiner({
        type: MinerActions.Location,
        payload: {
          name: location.name,
          address: location.address,
          id: "" + location.location_id,
          location_id: location.loc_id,
        },
      });
      break;

    case SocketEventTypes.MINER_TYPE:
      dispatchMiner({
        type: MinerActions.MinerType,
        payload: data,
      });
      break;

    case SocketEventTypes.MINER_DEFAULT_SPEED:
      dispatchMiner({
        type: MinerActions.DefaultSpeed,
        payload: data,
      });
      break;

    case SocketEventTypes.MINER_DROP_SPEED:
      dispatchMiner({
        type: MinerActions.DropSpeed,
        payload: data,
      });
      break;

    case SocketEventTypes.MINER_SETTINGS:
      dispatchMiner({
        type: MinerActions.Settings,
        payload: {
          setting_id: (data as MinerSettingsEvent).setting_id,
          name: (data as MinerSettingsEvent).name,
          is_own_mining: (data as MinerSettingsEvent).is_own_mining,
        } as IMinerSettings,
      });
      break;

    case SocketEventTypes.MINER_CUSTOMER:
      const user = data as MinerCustomerEvent;
      if (user) {
        dispatchMiner({
          type: MinerActions.Customer,
          payload: user,
        });
      }
      break;

    case SocketEventTypes.MINER_PLAN:
      console.log("Socket event MINER_PLAN", { data });
      dispatchMiner({
        type: MinerActions.Plan,
        payload: data,
        tag: "SOCKET"
      });
      break;

    case SocketEventTypes.MINER_PERCENT:
      dispatchMiner({
        type: MinerActions.Percent,
        payload: data,
      });
      break;

    case SocketEventTypes.MINER_SMOOTH:
      dispatchMiner({
        type: MinerActions.Smooth,
        payload: data,
      });
      break;
  }
};
